export default __webpack_public_path__ + "static/677-0d040b485ea7dae20034744db850f037.gif";